import { render, staticRenderFns } from "./OpeningHoursEditor.vue?vue&type=template&id=d9d5cfa8&scoped=true"
import script from "./OpeningHoursEditor.vue?vue&type=script&lang=ts"
export * from "./OpeningHoursEditor.vue?vue&type=script&lang=ts"
import style0 from "./OpeningHoursEditor.vue?vue&type=style&index=0&id=d9d5cfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d5cfa8",
  null
  
)

export default component.exports